import React from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { GameRoomListCard } from '../containers'
import { TitleGrid } from '../../../containers'
import GroupSelectCard from './GroupSelectCard'
import GroupUsersCard from './GroupUsersCard'
import GroupChatCard from './GroupChatCard'

const styles = theme => ({
})

class GameHome extends React.Component {  
  render() {
    return (
      <TitleGrid spacing={16}>
        <Grid item xs={12} md={3}>
          <GroupSelectCard/>
          <GroupUsersCard/>
          <GroupChatCard/>
        </Grid>
        <Grid item xs={12} md={9}>
          <GameRoomListCard/>
        </Grid>
      </TitleGrid>
    )
  }
}

export default withStyles(styles, { withTheme: true })(GameHome)



// WEBPACK FOOTER //
// ./src/Pages/Game/components/GameHome.js